// src/state/globalData.js
import { reactive } from 'vue';
import { api } from "@/helpers/mirai/custom";

// Estados reativos globais
export const grupoState = reactive({ data: [], loading: false, error: null });
export const localidadesState = reactive({ data: [], loading: false, error: null });
export const categoriasState = reactive({ data: [], loading: false, error: null });
export const tagsState = reactive({ data: [], loading: false, error: null });

const CACHE_PREFIX = "global_data_cache_v1";
const CACHE_TTL_MS = Object.freeze({
    localidades: 10 * 60 * 1000,
    grupos: 10 * 60 * 1000,
    categorias: 10 * 60 * 1000,
    tags: 10 * 60 * 1000,
});

const getCacheKey = (key) => `${CACHE_PREFIX}:${key}`;

const lerCache = (key, ttlMs) => {
    try {
        const bruto = localStorage.getItem(getCacheKey(key));
        if (!bruto) return null;
        const payload = JSON.parse(bruto);
        const savedAt = Number(payload?.savedAt || 0);
        if (!savedAt || (Date.now() - savedAt) > ttlMs) return null;
        return payload?.data ?? null;
    } catch (_error) {
        return null;
    }
};

const salvarCache = (key, data) => {
    try {
        localStorage.setItem(
            getCacheKey(key),
            JSON.stringify({
                savedAt: Date.now(),
                data,
            }),
        );
    } catch (_error) { return null; }
};

const carregarRecurso = async ({
    state,
    cacheKey,
    ttlMs,
    route,
}) => {
    state.error = null;

    const cacheValido = lerCache(cacheKey, ttlMs);
    if (cacheValido !== null) {
        state.data = cacheValido;
        state.loading = false;
        return cacheValido;
    }

    state.loading = true;
    try {
        const data = await api.read(route);
        if (data !== false && data !== null && data !== undefined) {
            state.data = data;
            salvarCache(cacheKey, data);
        }
        return state.data;
    } catch (error) {
        state.error = error;
        console.error(`Erro ao carregar ${cacheKey}:`, error);
        return state.data;
    } finally {
        state.loading = false;
    }
};

// Limpa os dados em memória e cache local
export function limparDadosGlobais() {
    grupoState.data = [];
    localidadesState.data = [];
    categoriasState.data = [];
    tagsState.data = [];

    try {
        localStorage.removeItem(getCacheKey('localidades'));
        localStorage.removeItem(getCacheKey('grupos'));
        localStorage.removeItem(getCacheKey('categorias'));
        localStorage.removeItem(getCacheKey('tags'));
    } catch (_error) { return null; }
}

// Carrega dados iniciais sem atraso artificial
export async function carregarDadosIniciais() {
    const isLoggedIn = localStorage.getItem('userid');
    if (!isLoggedIn) return;

    await Promise.allSettled([
        carregarRecurso({
            state: localidadesState,
            cacheKey: 'localidades',
            ttlMs: CACHE_TTL_MS.localidades,
            route: '/netbox/sites',
        }),
        carregarRecurso({
            state: grupoState,
            cacheKey: 'grupos',
            ttlMs: CACHE_TTL_MS.grupos,
            route: '/grupo',
        }),
        carregarRecurso({
            state: categoriasState,
            cacheKey: 'categorias',
            ttlMs: CACHE_TTL_MS.categorias,
            route: '/categoria',
        }),
        carregarRecurso({
            state: tagsState,
            cacheKey: 'tags',
            ttlMs: CACHE_TTL_MS.tags,
            route: '/tag',
        }),
    ]);
}

